module.exports = __webpack_public_path__ + "191206_Okko_deisel_Sova_15s_new_legal.mp4?e4f26ee83d03bfd0033ac854b2728067";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/191206_Okko_deisel_Sova_15s_new_legal.mp4
// module id = 154
// module chunks = 0